// authStore.ts
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import type { AuthUser } from "@/features/auth/types";

interface AuthState {
  user: AuthUser | null;
  setUser: (user: AuthUser | null) => void;
}

export const useAuthStore = create<AuthState>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        setUser: (user: AuthUser | null) => {
          if (user) {
            const avatarName = `${user.first_name[0] || ""}${
              user.last_name[0] || ""
            }`;
            const updatedUser = {
              ...user,
              avatar_name: avatarName,
            };
            set({ user: updatedUser });
          } else {
            set({ user });
          }
        },
      }),
      {
        name: "auth-user-storage",
      }
    )
  )
);
